import React from 'react'
import { useLocation } from 'react-router-dom'
import { Table } from '../Table/Table'

const useQuery = () => {
  return new URLSearchParams(useLocation().search)
}

export function OktaProfileLogs() {
  const query = useQuery()

  const email = query.get('email') || ''
  const startTime = query.get('startTime') || ''
  const endTime = query.get('endTime') || ''

  return (
    <div className="row">
      <div className="">
        <Table email={email} startTime={startTime} endTime={endTime} />
      </div>
    </div>
  )
}
